import { NgModule } from '@angular/core';

import { PatientHistoryApiService } from './patient-history.service';

@NgModule({
    providers: [PatientHistoryApiService],
})
export class PatientHistoryApiModule {}

